<template>
  <CloseCircleButtonModal
    class="gift-card-preview-modal"
    title-text="相手に届く画面"
    @clicked-modal-cover="onClickModalCover"
    @clicked-close="onClickCloseButton"
  >
    <Preview
      :card-design-image-url="cardDesignImageUrl"
      :sender-name="senderName"
      :profile-icon-image-url="profileIconImageUrl"
      :profile-link="profileLink"
      :message="message"
      :item-sku-contents="itemSkuContents"
    />
  </CloseCircleButtonModal>
</template>

<script setup>
import CloseCircleButtonModal from '../CloseCircleButtonModal.vue'
import Preview from '../../gift_card/Preview.vue'

defineProps({
  cardDesignImageUrl: {
    type: String,
    required: true
  },
  senderName: {
    type: String,
    required: true
  },
  profileIconImageUrl: {
    type: String,
    required: false,
    default: ''
  },
  profileLink: {
    type: Boolean,
    required: false,
    default: false
  },
  message: {
    type: String,
    required: false,
    default: ''
  },
  itemSkuContents: {
    type: Array,
    required: true
  }
})

const emit = defineEmits(['clicked-modal-cover', 'clicked-close'])

const onClickModalCover = () => {
  emit('clicked-modal-cover')
}
const onClickCloseButton = () => {
  emit('clicked-close')
}
</script>
<style lang="scss" scoped>
.gift-card-preview-modal {
  :deep(.close-circle-button-modal__body) {
    padding: 0;
  }
}
</style>
